import { EVENT_ROLE, EventRoleStatus, STATUS } from '@type/db-types';
import { log } from '@utils/logging';
import { Tag } from 'antd';

// moved this here to support fast refresh
const capitalizeFirstLetter = (val: string) =>
    String(val).charAt(0).toUpperCase() + String(val).slice(1);

export function MembershipStatusChip({
    status,
    role,
    count,
}: {
    status: EventRoleStatus['membershipStatus'] | null;
    role: EventRoleStatus['membershipRole'] | null;
    count: number | null;
}) {
    if (!status || !role) return null;

    // handle event admins
    if ([EVENT_ROLE.OWNER, EVENT_ROLE.STAFF].includes(role)) {
        if (status === STATUS.ACTIVE) {
            return <Tag color="default">Owner</Tag>;
        } else {
            return <Tag color="warning">{`${capitalizeFirstLetter(role)} (${status})`}</Tag>;
        }
    }

    const countStr = count ? ` (${count})` : '';

    switch (status) {
        case STATUS.ACTIVE:
            return <Tag color="success">{'Signed Up' + countStr}</Tag>;
        case STATUS.PENDING:
            return <Tag color="warning">{'Waiting for Approval' + countStr}</Tag>;
        case STATUS.CANCELLED || STATUS.DECLINED:
            return <Tag color="error">{status}</Tag>;
        case STATUS.INVITED:
            return <Tag color="info">{status}</Tag>;

        default:
            log(`unrecognized membership status: ${status}`);

            return '';
    }
}
